import { registerShellI18next } from "./i18n/i18next.ts";
import { registerMswPages } from "./mocks/registerMswPages.tsx";
import { registerMswRequestHandlers } from "./mocks/registerMswRequestHandlers.ts";
import type { ModuleRegisterFunction } from "./moduleRegisterFunction.ts";
import { registerAppShell } from "./registerAppShell.tsx";

export const registerShell: ModuleRegisterFunction = async runtime => {
    await registerShellI18next(runtime);

    await registerMswRequestHandlers(runtime);

    await registerMsw(runtime);
    await registerMswPages(runtime);
    await registerAppShell(runtime);
};

const registerMsw: ModuleRegisterFunction = async runtime => {
    if (runtime.isMswEnabled) {
        const apiHandlers = (await import("./api/handlers.ts")).handlers;
        const scenarios = (await import("./api/handlers.ts")).scenarios;
        const getEnabledScenarios = (await import("@sg-protect/core/mocks")).getEnabledScenarios;
        const getScenarioHandlers = (await import("@sg-protect/core/mocks")).getScenarioHandlers;

        const enabledScenarios = getEnabledScenarios();
        const scenarioHandlers = getScenarioHandlers(scenarios, enabledScenarios);
        const requestHandlers = [...scenarioHandlers, ...apiHandlers];

        // Tags handlers so DUMP_MSW_MOCKS=true (pnpm dev-msw:dump) can report which module each mock came from.
        requestHandlers.forEach(handler => Object.assign(handler, { mockModule: "shell" }));

        runtime.registerRequestHandlers(requestHandlers);
    }
};
